import config from "@/config/select";
export default {
  props: {
    apiObj: {
      type: Object,
      default: () => {}
    },
    dic: {
      type: String,
      default: ""
    },
    objValueType: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dicParams: this.params,
      loading: false,
      options: [],
      props: config.props,
      initloading: false
    };
  },
  created() {
    //如果有默认值就去请求接口获取options
    if (this.hasValue()) {
      this.initloading = true;
      this.getRemoteData();
    }
  },
  methods: {
    //选项显示隐藏事件
    visibleChange(ispoen) {
      if (ispoen && this.options.length == 0 && (this.dic || this.apiObj)) {
        this.getRemoteData();
      }
    },
    //获取数据
    async getRemoteData() {
      this.loading = true;
      this.dicParams[config.request.name] = this.dic;
      var res = {};
      if (this.apiObj) {
        res = await this.apiObj.get(this.params);
      } else if (this.dic) {
        res = await config.dicApiObj.get(this.params);
      }
      var response = config.parseData(res);
      this.options = response.data;
      this.loading = false;
      this.initloading = false;
    },
    //判断是否有回显默认值
    hasValue() {
      if (Array.isArray(this.$attrs.modelValue) && this.$attrs.modelValue.length <= 0) {
        return false;
      } else if (this.$attrs.modelValue) {
        return true;
      } else {
        return false;
      }
    }
  }
};